/**
 * Routes and API endpoints that must work without authentication
 * (e.g. candidate self-registration, job fair registration links).
 */

const PUBLIC_APP_ROUTE_PATTERNS = [
  /^\/candidate-form\/[^/]+$/,
  /^\/job-fair-form\/[^/]+$/,
  /^\/invoice\/[^/]+$/
];

const PUBLIC_API_PREFIXES = [
  '/public/candidate-links/',
  '/public/job-fair/',
  '/public/invoices/',
  '/public/education-options',
  '/public/locations',
  '/public/skills',
];

export const isPublicAppRoute = (pathname) => {
  const path = (pathname || '').split('?')[0];
  return PUBLIC_APP_ROUTE_PATTERNS.some((pattern) => pattern.test(path));
};

export const isPublicApiEndpoint = (endpoint) => {
  const normalized = endpoint?.startsWith('/') ? endpoint : `/${endpoint || ''}`;
  return PUBLIC_API_PREFIXES.some((prefix) => normalized.startsWith(prefix));
};
